import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//component ui:
import DatePicker from '../../utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginLeft: 25,
        marginTop: 35,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditCentroMaquina extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.centro.id ? this.props.centro.id : uuidv4(),
            centro: this.props.centro.centro
                ? this.props.centro.centro
                : this.props.centros[0].descr,
            centroId: this.props.centro.centroId
                ? this.props.centro.centroId
                : this.props.centros[0].id,
            fIni: this.props.centro.fIni
                ? this.props.centro.fIni.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            fEnd: this.props.centro.fEnd
                ? this.props.centro.fEnd.slice(0, 10)
                : null,
            maquinaId: this.props.centro.maquinaId
                ? this.props.centro.maquinaId
                : this.props.maquinaId,
        };
    }

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    handleSelectChange = event => {
        const descr = this.props.centros.find(c => c.id === parseInt(event.target.value)).centro;
        this.setState({
            ...this.state,
            centro: descr,
            centroId: event.target.value,
        });
    };

    fillCentrosOptions = () => {
        return this.props.centros
            .filter(c => c.isGroup === false)
            .map((c, i) => {
                return (
                    <option key={'centro_' + i} value={c.id}>
                        {c.centro}
                    </option>
                );
            });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="centro-placeholder">
                            Centro
                        </InputLabel>
                        <Select
                            native
                            value={this.state.centroId}
                            onChange={event => this.handleSelectChange(event)}
                            name="centro"
                            input={<Input id="centros" />}
                        >
                            {this.fillCentrosOptions()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <DatePicker
                            label={'Fecha de alta'}
                            value={this.state.fIni}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fIni')
                                }
                            }}
                        />
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <DatePicker
                            label={'Fecha de baja'}
                            value={this.state.fEnd}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fEnd')
                                }
                                else {
                                    this.handleValueChangeDate(null, 'fEnd')
                                }
                            }}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const centro = {
                                id: this.state.id,
                                fEnd: this.state.fEnd,
                                fIni: this.state.fIni,
                                maquinaId: this.state.maquinaId,
                                centro: this.state.centro,
                                centroId: this.state.centroId,
                            };

                            if (this.props.checkCentro(centro)) {
                                this.props.okHandler(centro);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditCentroMaquina.propTypes = {
    itv: PropTypes.object.isRequired,
    maquinaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkItv: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditCentroMaquina);
